import { Component, Input } from '@angular/core';

@Component ({
  selector: 'block-ui',
  templateUrl: 'block-ui.template.html',
  styleUrls: ['block-ui.style.scss']
})
export class BlockUIComponent {
  @Input()
  public title: string;
  @Input()
  public data: any;
}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/MZoVYbaM/0/has-gas/lora-wan/lora-ui/src/app/components/block/block-ui.component.ts